export default "__VITE_ASSET__BEwOkAbA__"